/**
 * the details tag and tailwind accordion is not suitable,
 * because here we need a division into mobile and desktop versions
 */

document.addEventListener('DOMContentLoaded', () => {

    document
        .querySelectorAll('[data-custom-accordion]')
        .forEach((container) => {

            const putClassName = container.dataset.accordionPut;
            container
                .querySelectorAll('[data-accordion-toggle]')
                .forEach((toggle) => {

                    const
                        targetId = toggle.dataset.accordionToggle,
                        content = container.querySelector(`[data-accordion-content="${targetId}"]`),
                        icon = toggle.querySelector('[data-accordion-icon]');

                    toggle.addEventListener('click', () => {

                        icon.classList.toggle('rotate-180');
                        content.classList.toggle(putClassName);
                    });
                });
        });
});